// extracted by mini-css-extract-plugin
export default {"input":"mininput_input__wHFt-"};